import { z } from 'zod';

export const userTypeSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
});

export const userTypeListSchema = z.array(userTypeSchema);

export type UserType = z.infer<typeof userTypeSchema>;
